export function resetMainTabScroll(positions,current,next){
 if(next!==current)positions.delete(JSON.stringify([next]));
}
